import { type RenderElementProps } from 'slate-react'

export default function Video({ attributes, element }: RenderElementProps) {
  if (element.type !== 'video') throw new Error('Unsupported file type')

  return (
    <div {...attributes} className="relative mb-4" contentEditable={false}>
      <video src={element.url} controls className="w-full" />
    </div>
  )
}
